module.exports = __webpack_public_path__ + "img/bz_btn.bedcfbdf.png";